import { useSnackbar } from "notistack";
import React from "react";

import { useMutation } from "@apollo/client";
import { AppBar, Hidden, Stack, Toolbar, Typography } from "@mui/material";
import { Box } from "@mui/system";

import USLogout from "../../graphql/mutation/USLogout.mutation";
import translateErrors from "../../graphql/utils/translateErrors";
import NavAccountButton from "./NavAccountButton";
import NavIcon from "./NavIcon";
import NavMenu from "./NavMenu";

interface NavbarProps {
  firstName: string;
}

const Navbar = ({ firstName }: NavbarProps) => {
  const [logout] = useMutation(USLogout);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const { enqueueSnackbar } = useSnackbar();
  const menuId = "account-menu";

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    try {
      window.location.reload();
      await logout();
    } catch (error: any) {
      enqueueSnackbar(translateErrors(error.graphQLErrors ), {
        variant: "error",
        transitionDuration: { appear: 500, enter: 425, exit: 195 },
      });
    }
  };

  return (
    <>
      <AppBar sx={{ px: 2 }}>
        <Toolbar>
          <NavIcon />
          <Box sx={{ flexGrow: 1 }} />
          <Stack direction="row" alignItems="center" spacing={2}>
            <Hidden smDown>
              <Typography color="white" variant="body1">
                สวัสดี, คุณ{firstName}
              </Typography>
            </Hidden>
            <NavAccountButton
              id={menuId}
              handleProfileMenuOpen={handleProfileMenuOpen}
            />
          </Stack>
        </Toolbar>
      </AppBar>
      <NavMenu
        id={menuId}
        anchorEl={anchorEl}
        handleMenuClose={handleMenuClose}
        handleLogout={handleLogout}
      />
    </>
  );
};

export default Navbar;
